export const phoneNumberRegex = /^\+?(\d[-, ]?){10,}$/;
